'use strict';

export default class Settings {
  constructor(appConfig, $http, $q) {
    'ngInject';

    this._appConfig = appConfig;
    this._$http = $http;
    this._$q = $q;
  }

  query() {
    // Create the $http object for this request
    let request = {
      url: `${this._appConfig.api}/settings`,
      method: 'GET',
    };
    return this._$http(request).then(res => res.data);
  }

  lookup() {
    // Create the $http object for this request
    let request = {
      url: `${this._appConfig.api}/settings`,
      method: 'GET',
    };
    return this._$http(request).then(res => {
      let settings = {};
      for(let setting of res.data) {
        settings[setting.name] = setting.value;
      }
      return settings;
    });
  }

  save(setting) {
    let request = {};

    if(setting._id) {
      request.url = `${this._appConfig.api}/settings/${setting._id}`;
      request.method = 'PUT';
    } else {
      request.url = `${this._appConfig.api}/settings`;
      request.method = 'POST';
    }

    request.data = setting;

    return this._$http(request).then(res => res.data);
  }
  //
  //  stats(){
  //    let request = {
  //      url: this._appConfig.api + '/applications/stats',
  //      method: 'GET',
  //    };
  //    return this._$http(request).then((res) => res.data);
  //  }
}



// WEBPACK FOOTER //
// ./client/components/services/settings.service.js